module.exports = __webpack_public_path__ + "img/google-logo.32dcc028.svg";